/** Chrono default Walt — from GET /agent/list?agent_type=user_created */
export const DEFAULT_WALT_ID = 'c63eb44c-5fe7-47ab-9f6f-9b731911e630';

/** Legacy hardcoded id from older Chrono builds — treat as Walt for migration. */
export const LEGACY_WALT_ID = '5b005476-0bc6-4327-9f7d-3df2cdbd67a2';

export const LEGACY_WALT_IDS = new Set([LEGACY_WALT_ID, DEFAULT_WALT_ID]);

export const DEFAULT_WALT_ICON =
  'https://feedalabs-agent-icon.s3.eu-north-1.amazonaws.com/Walt_21ca3dd6af8048b5bb1124cc174a2c8a.png';

export const DEFAULT_WALT_AGENT = {
  label: 'Walt',
  value: DEFAULT_WALT_ID,
  icon: DEFAULT_WALT_ICON,
  mode: 'agent',
};
